import './Game.scss';
import { RootState } from '../store';
import { useAppSelector } from '../redux'
import { GamePlayState } from "../Enums/GameEnums";
import HealthBar from "./HealthBar";
import BlackjackCards from './BlackjackCards';
import { MONSTER_CLASSES } from '../Enums/Attributes';
import SpritesheetAsset from '../Components/SpritesheetAsset';

function MonsterBlackjack() {
  const gameState = useAppSelector((state: RootState) => state.game)
  const engineState = gameState.engineState
  const monster = MONSTER_CLASSES.find(x => x.name === gameState.monster.name);
  const gamePlayState = gameState.gamePlayState

  return (
    <div className="monster-blackjack">
      <div className="monster-blackjack_name">
        <p>{gameState.monster.namePrefix}</p>
        {monster.boss &&
          <div className='monster-chest'>
            <SpritesheetAsset name="chest.png" multiplier={1} />
          </div>}
      </div>

      <HealthBar type="monster" currentHP={gameState.monster.attributes.currentHp} maxHP={gameState.monster.attributes.maxHp} />
      {gamePlayState !== GamePlayState.BETTING && // corner case, when returning to ongoing game
        <BlackjackCards cards={engineState?.dealerCards} label={engineState?.dealerValue} owner={"monster"} />
      }

      <div className='monster-blackjack_stats'>
        <span className='attr-title'>Att:{gameState.monster.attributes.att}</span>
        <span className='attr-title'>Def:{gameState.monster.attributes.def}</span>
        <span className='attr-title'>Prc:{gameState.monster.attributes.pierce}</span>
      </div>
    </div>
  );
}

export default MonsterBlackjack;
